import React from "react";
import { ExerciseAssetStatus } from "@growth-machine-llc/stridist-api-client";
import { ExercisesTable } from "../../../../../components/exercise-library/ExercisesTableScreen";
import TrackInfoTool from "../../../../../components/tools/TrackInfoTool";

export const CoachExerciseLibraryList = ({
  status,
}: {
  status: ExerciseAssetStatus;
}) => {
  return <ExercisesTable status={status} />;
};

export const CoachExerciseLibraryPublishedRoute = () => {
  return <CoachExerciseLibraryList status={ExerciseAssetStatus.PUBLISHED} />;
};

export const CoachExerciseLibraryArchiveRoute = () => {
  return <CoachExerciseLibraryList status={ExerciseAssetStatus.ARCHIVED} />;
};

export const CoachExerciseLibraryPendingRoute = () => {
  return (
    <>
      <CoachExerciseLibraryList status={ExerciseAssetStatus.PENDING} />
      <TrackInfoTool
        trackInfo={{
          name: "Coach - Pending Assets",
        }}
      />
    </>
  );
};
